import { createFileRoute, Link } from "@tanstack/react-router";
import { canonical } from "@/components/site/site-config";
import { CityPageBody } from "@/components/site/CityPageBody";
import { BUSINESS } from "@/components/site/constants";
import { GALVALUME_INVERNESS } from "@/components/site/images";

export const Route = createFileRoute("/roofing-company-inverness-fl")({
  head: () => ({
    meta: [
      { title: "Roofing Company in Inverness, FL | Destination Roofing" },
      { name: "description", content: `Local Inverness roofing company for roof replacement, leak repair, metal and shingle roofing, gutters, soffit and free inspections. Call ${BUSINESS.phone}.` },
      { property: "og:title", content: "Roofing Company in Inverness, FL | Destination Roofing" },
      { property: "og:description", content: "Local family-owned roofer in Inverness, FL. Free Roof Inspection & Estimate." },
      { property: "og:url", content: canonical("/roofing-company-inverness-fl") },
      { property: "og:type", content: "website" },
      { property: "og:image", content: GALVALUME_INVERNESS.fallback },
    ],
    links: [{ rel: "canonical", href: canonical("/roofing-company-inverness-fl") }],
  }),
  component: () => (
    <CityPageBody
      city="Inverness"
      slug="/roofing-company-inverness-fl"
      image={GALVALUME_INVERNESS}
      imageAlt="Galvalume metal roof replacement completed by Destination Roofing in Inverness, Florida"
      imageCaption="Residential Galvalume metal-roof replacement in Inverness, FL."
      localProof={
        <div className="my-6 not-prose rounded-xl border border-border bg-card p-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Recent work near Inverness</p>
          <ul className="mt-2 space-y-1 text-sm">
            <li><Link to="/projects/galvalume-metal-roof-hernando-fl" className="font-semibold text-primary hover:underline">Galvalume metal roof — Hernando, FL</Link></li>
            <li><Link to="/projects/shingle-roof-replacement-beverly-hills-fl" className="font-semibold text-primary hover:underline">Shingle roof replacement — Beverly Hills, FL</Link></li>
          </ul>
        </div>
      }
      permitNote={
        <p>
          Homes inside Inverness city limits are permitted through the City of Inverness, while homes outside city limits go through the Citrus County Building Division. See our <Link to="/citrus-county-roof-permits">Citrus County roof permit guide</Link>.
        </p>
      }
      intro={
        <p>
          Inverness is one of the older communities in Citrus County, which means we see a broad mix of housing stock — from historic homes near downtown and the lake to newer builds in the surrounding neighborhoods. Each has different roofing needs.
        </p>
      }
      localNotes={
        <>
          <p>
            Older Inverness homes often have complex rooflines with multiple valleys, dormers, and additions tied in over the years. Those transitions are exactly where leaks tend to start, so a careful inspection matters. On newer builds we mostly see straightforward architectural shingle wear and normal Florida sun damage.
          </p>
          <p>
            Because of the lakes and mature tree canopy in the area, gutter and soffit issues are also common — heavy debris load leads to overflow, which quietly damages fascia over time.
          </p>
        </>
      }
    />
  ),
});
